export default __webpack_public_path__ + "static/media/instagram_post_holiday.5afaace6.png";